import { createSlice } from '@reduxjs/toolkit'
import { getListLiveJump, getListLiveLean, getListLivePeople } from '../action/liveDetectionAction'

const initialState = {
  dataLiveCount: [],
  dataLiveLean: '',
  dataLiveJump: '',
  idSummary: '',
  state: '',
  isOpenFormSummary: false,
  isLoading: false,
}
const liveDetectionSlice = createSlice({
  name: 'liveDetection',
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenFormSummary = action.payload.open
      state.state = action.payload.state
      if (action.payload.state === 'edit') {
        state.dataByIdSummary = action.payload.data
        state.idSummary = action.payload.id
      } else if (action.payload.state === 'delete') {
        state.dataByIdSummary = action.payload.data
        state.idSummary = action.payload.id
      }
    },
  },
  extraReducers: {
    [getListLivePeople.pending]: (state) => {
      state.isLoading = true
    },
    [getListLivePeople.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataLiveCount = action.payload.data
      state.isLoading = false
    },
    [getListLivePeople.rejected]: (state) => {
      state.isLoading = false
    },
    [getListLiveLean.pending]: (state) => {
      state.isLoading = true
    },
    [getListLiveLean.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataLiveLean = action.payload.data
      state.isLoading = false
    },
    [getListLiveLean.rejected]: (state) => {
      state.isLoading = false
    },
    [getListLiveJump.pending]: (state) => {
      state.isLoading = true
    },
    [getListLiveJump.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataLiveJump = action.payload.data
      state.isLoading = false
    },
    [getListLiveJump.rejected]: (state) => {
      state.isLoading = false
    },
  },
})

export const { openForm } = liveDetectionSlice.actions
export default liveDetectionSlice.reducer
